import { FC } from 'react';
import { createPortal } from 'react-dom';
import styles from './index.module.scss';

interface ModalProps {
    visible: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
    className?: string;
}

const Modal: FC<ModalProps> = ({ visible, onClose, title, children, className }) => {
    if (!visible) return null;

    return createPortal(
        <div className={`${styles.modal} ${className}`}>
            <div className="modal-overlay" />
            <div className="modal-container">
                <div className="modal-header">
                    <h3 className="modal-title">{title}</h3>
                    <button className="modal-close" onClick={onClose}>
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6.57129L6 18.5713" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 6.57129L18 18.5713" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>
                <div className="modal-content">{children}</div>
            </div>
        </div>,
        document.body,
    );
};

export default Modal;
